import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Loader2 } from 'lucide-react';
import { legalApi } from '../../lib/api';

/**
 * Lädt einen rechtlichen Text (Nutzungsbedingungen oder Datenschutzhinweis)
 * vom Backend und zeigt ihn in einem Pop-up. Wird vom Registrierungs-/Login-
 * Formular eingebunden, damit der Nutzer die Seite nicht verlassen muss.
 *
 * Props:
 *  - type: 'terms_of_service' | 'privacy_policy'
 *  - open: boolean
 *  - onOpenChange: (open) => void
 */
export default function LegalDialog({ type, open, onOpenChange }) {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(false);
    const titles = {
        terms_of_service: 'Nutzungsbedingungen',
        privacy_policy: 'Datenschutzhinweise',
        imprint: 'Impressum',
    };
    const title = titles[type] || 'Information';

    useEffect(() => {
        if (!open || !type) return;
        setLoading(true);
        legalApi.get(type)
            .then((r) => setContent(r.data?.html_content || ''))
            .catch(() => setContent(''))
            .finally(() => setLoading(false));
    }, [open, type]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid={`legal-dialog-${type}`}>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                {loading ? (
                    <div className="py-12 flex justify-center">
                        <Loader2 className="h-6 w-6 animate-spin text-primary" />
                    </div>
                ) : content ? (
                    <div
                        className="legal-html max-w-none text-gray-700"
                        dangerouslySetInnerHTML={{ __html: content }}
                        data-testid="legal-dialog-content"
                    />
                ) : (
                    <p className="text-sm text-gray-500 py-8 text-center">
                        Dieser Text wurde noch nicht hinterlegt.
                    </p>
                )}
            </DialogContent>
        </Dialog>
    );
}
